import { TextInput } from '@perpay-web/components/base/TextInput/TextInput';
import { withFormServerErrors } from '@perpay-web/components/higher-order/WithFieldServerErrors/WithFormServerErrors';

const TextInputServerError = withFormServerErrors(TextInput);

export default TextInputServerError;
